module.exports = __webpack_public_path__ + "img/图片2.c83c5ebf.png";